// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";

var custom_modal_styles = {
  overlay: {
    zIndex: 10,
    backgroundColor: "rgba(0, 0, 0, 0.50)"
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "45rem",
    padding: "0",
    border: "none"
  }
};

var reason_items = {
  hd: {
    key: "0",
    value: "-1",
    text: "Select a reason"
  },
  tl: {
    hd: {
      key: "1",
      value: "settle_customer_dues",
      text: "Settle dues on payment through NEFT/RTGS/cheque/other"
    },
    tl: {
      hd: {
        key: "2",
        value: "manual_cashback",
        text: "Cashback"
      },
      tl: {
        hd: {
          key: "3",
          value: "others",
          text: "Others"
        },
        tl: {
          hd: {
            key: "4",
            value: "settled_intercity_partload",
            text: "Settled for Intercity Partload"
          },
          tl: {
            hd: {
              key: "5",
              value: "adjusted_against_tds",
              text: "Adjusted against TDS"
            },
            tl: {
              hd: {
                key: "6",
                value: "packers_and_movers_advance_charge",
                text: "Packers and Movers advance amount"
              },
              tl: {
                hd: {
                  key: "7",
                  value: "porter_customer_reward_program",
                  text: "Porter customer reward program"
                },
                tl: {
                  hd: {
                    key: "8",
                    value: "courier_order_charges",
                    text: "Courier - Order Charges"
                  },
                  tl: {
                    hd: {
                      key: "9",
                      value: "courier_weight_discrepancy_charges",
                      text: "Courier - Weight Discrepancy Charges"
                    },
                    tl: {
                      hd: {
                        key: "10",
                        value: "courier_rto_charges",
                        text: "Courier - RTO Charge"
                      },
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function getSelectedItem(value) {
  if (List.exists((function (a) {
            return a.value === value;
          }), reason_items)) {
    return List.find((function (item) {
                  return item.value === value;
                }), reason_items);
  }
  
}

var update_amount_regex = /^(-?1(?:[0]{5})?|0)$|^(-?([1-9]\d{0,4}|[0]{1,4}[1-9]))(?:\.\d{1,2})?$/;

export {
  custom_modal_styles ,
  reason_items ,
  getSelectedItem ,
  update_amount_regex ,
  
}
/* No side effect */
